import './App.css'
import Menu from './componente/Menu'

function App() {
  return (
    <div className='App'>
      <Menu />
      <footer>
        created by -
        <a href='https://github.com/jyotip101/menu-page-in-react'>Jyoti-p</a>
      </footer>
    </div>
  )
}

export default App
